import Header from "@/components/ui/Header";
import { useNavigate } from "react-router-dom";
import { Anchor } from "lucide-react";

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background text-foreground">

    <Header />

      {/* Content */}
      <div className="max-w-3xl mx-auto p-6">

        <h1 className="text-3xl font-bold mb-6">About MarineKnow</h1>

        <p className="mb-4">
          MarineKnow was created by seafarers to bring transparency to life at sea.
        </p>

        <p className="mb-4">
          Every ship is different and every contract can be a completely different
          experience. Too often, seafarers join vessels without knowing what to expect —
          workload, crew culture, food quality, internet availability, or overall
          onboard environment.
        </p>

        <p className="mb-4">
          MarineKnow allows seafarers to anonymously share real insights about ships
          so others can make informed decisions before joining a vessel.
        </p>

        <p className="mb-4">
          Our goal is simple: build a transparent database of ship experiences
          contributed by real crew members.
        </p>

        <p className="font-semibold mt-6 text-primary">
          By sailors, for sailors.
        </p>

        <p className="text-sm text-muted-foreground mt-2">
          Created by 2nd Officer Yogesh Mane
        </p>

        {/* Back Button */}
        <button
          onClick={() => navigate("/")}
          className="mt-8 text-primary underline hover:opacity-80"
        >
          Back to Home
        </button>

      </div>
    </div>
  );
};

export default About;
